module.exports = __webpack_public_path__ + "img/section1ModelM.697f118f.png";